import { func_print } from "./func_print"

export const sum_column_from_array = (column_name: string, array: any) => {
    let aux = array.reduce(
        (accumulator: any, currentValue: any) => {
            return parseFloat(accumulator) + parseFloat(currentValue[column_name])
        },
        0
    )
    return Number.isNaN(aux) === false ? aux : 0

}
